import { useState, useEffect } from 'react'
import axios from 'axios'
import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import { about } from '../../portfolio'
import './About.css'

const About = () => {
  const [status, setStatus] = useState({})

  useEffect(() => {
    async function getDetails() {

      try {
        const response = await axios.get(
          'https://api.lanyard.rest/v1/users/507946813614194689'
        )
        setStatus(response.data.data)
      } catch (error) {
        console.error(error)
      }
    }
    getDetails()
    setInterval(() => {
      getDetails()
    }, 5000)
  }, [])
  const { name, role, social } = about

  return (
    <div className='about center'>
      {name && (
        <h1>
          Hi, I am <span className='about__name'>{name}.</span>
        </h1>
      )}

      {role && <h2 className='about__role'>A {role}.</h2>}
      <p className='about__desc'>
        I&apos;m currently online to reply && <br />
        {status.listening_to_spotify ? (
          <>
            <br />
            Listening to <strong>{status.spotify.song}</strong> by{' '}
            <strong>{status.spotify.artist}</strong>
            <br />
          </>
        ) : (
          <></>
        )}
        <br />
        {
          // if status.acitivities array has size > 0 then loop through it and find if any of the activities name is visual studio code
          status.activities ? (
            <>
              {status.activities.map((activity) => {
                if (activity.name.toLowerCase().includes('visual studio code') || activity.name.toLowerCase().includes('code')) {
                  return (
                    <>
                      Coding{' '}
                      <strong key={activity.name}>{activity.state}</strong>{' '}
                      &nbsp;for&nbsp;
                      {/* minus current timestamp from {activity.start} and get hours and minutes */}
                      {Math.floor(
                        (Date.now() - new Date(activity.timestamps.start)) /
                        1000 /
                        60 /
                        60
                      )}{' '}
                      hours and &nbsp;
                      {/* {Math.floor(
                        (Date.now() - new Date(activity.timestamps.start)) /
                          1000 /
                          60
                      )}{' '} */}
                      {/* if hours are > 1 then minus their minutes */}
                      {Math.floor(
                        (Date.now() - new Date(activity.timestamps.start)) /
                        1000 /
                        60 -
                        Math.floor(
                          (Date.now() - new Date(activity.timestamps.start)) /
                          1000 /
                          60 /
                          60
                        ) *
                        60
                      )}{' '}
                      minutes
                    </>
                  )
                }
                // check for valorant as well
                if (activity.name === 'VALORANT') {
                  return (
                    <>
                      <br />
                      Playing <strong>{activity.name}</strong> &nbsp;for&nbsp;
                      {Math.floor(
                        (Date.now() - new Date(activity.timestamps.start)) /
                        1000 /
                        60 /
                        60
                      )}{' '}
                      hours and &nbsp;
                      {Math.floor(
                        (Date.now() - new Date(activity.timestamps.start)) /
                        1000 /
                        60
                      )}{' '}
                      minutes
                    </>
                  )
                }
                return <></>
              })}
            </>
          ) : (
            <></>
          )
        }
      </p>

      <div className='about__contact center'>
        {/* {resume && (
          <a href={resume}>
            <span type='button' className='btn btn--outline'>
              Resume
            </span>
          </a>
        )} */}

        {social && (
          <>
            {social.github && (
              <a
                href={social.github}
                aria-label='github'
                className='link link--icon'
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label='linkedin'
                className='link link--icon'
              >
                <LinkedInIcon />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default About
